<template>
    <div class="user-roles-permissions">
        
         <b-collapse class="card" animation="slide" :open="false">

            <div slot="trigger" slot-scope="props" class="card-header" role="button">
                
                <a class="card-header-icon">
            
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
            
                </a> 

                <span class="card-header-icon">
                    <b-checkbox :value="areAllRolesChecked" @input="toggleAllRoles" @click.native.stop />
                </span>

                <p class="card-header-title">All</p> 
            
                <p class="card-header-icon">{{ checkedPermissions.length }}/{{ allPermissions.length }}</p> 
            
                <a class="card-header-icon">
            
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
            
                </a>

            </div>

            <div class="card-content">
            
                <div class="content">

                    <p v-if="allPermissions.length == 0">No permission</p>

                    <table class="table is-bordered" v-else>
                        <tr>
                            <th width="10">

                                <b-checkbox v-model="all" @change.native="checkAllPermission"></b-checkbox>
                          
                            </th>
                            <th width="50%">Check/Uncheck All</th>
                            <th>Notes</th>
                        </tr>
                        <tr v-for="permission in allPermissions" :key="permission.id">
                            <td width="10">
                                <b-checkbox
                                    :native-value="permission.id"
                                    v-model="checkedPermissions"
                                ></b-checkbox>
                            </td>
                            <td>{{ permission.name }}</td>
                            <td>{{ permission.notes }}</td>

                        </tr>
                    </table>

                </div>
            
            </div>

        </b-collapse>


        <b-collapse
            class="card"
            :aria-id="`role-`.index"
            :open="false"
            v-for="(role, index) in roles"
            :key="index"
        >
            <div
                slot="trigger"
                slot-scope="props"
                class="card-header"
                role="button"
                :aria-controls="`role-`.index"
            >
                <a class="card-header-icon">
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
                </a>
                <span class="card-header-icon">
                    <b-checkbox
                        v-model="checkedRoles_"
                        :native-value="role.id"
                        @click.native.stop
                    />
                </span>
                <p class="card-header-title">{{ role.name }}</p>
                <p
                    class="card-header-icon"
                >{{ ishaveValue ? rolePermissionsCheckedCount(role.permissions) : '0' }}/{{ role.permissions.length }}</p>
                <a class="card-header-icon">
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
                </a>
            </div>
            <div class="card-content">
                <div class="content">
                    <p v-if="role.permissions.length == 0">No permission</p>
                    <table class="table is-bordered" v-else>
                        <tr>
                            <th width="10">
                                <b-checkbox
                                    v-model="checkedAllPermissionInRoles"
                                    :native-value="role.id"
                                    @change.native="checkAll(role)"
                                ></b-checkbox>
                            </th>
                            <th width="50%">Check/Uncheck All</th>
                            <th>Notes</th>
                        </tr>
                        <tr v-for="permission in rolePermissions(role)" :key="permission.id">
                        <!-- <tr v-for="permission in role.permissions" :key="permission.id"> -->
                            <td width="10">
                                <b-checkbox
                                    :native-value="permission.id"
                                    v-model="checkedPermissions"
                                ></b-checkbox>
                            </td>
                            <td>{{ permission.name }}</td>
                            <td>{{ permission.notes }}</td>
                        </tr>
                    </table>
                </div>
            </div>
                
            <!-- {{ rolePermissions(role) }} -->

        </b-collapse>
    </div>
</template>
<script>

import { RoleService } from "@/services/role.service";

import { PermissionService } from "@/services/permission.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
    props: {
        checked: {
            type: Array,
            default: () => []
        },
        checkedRoles: {
            type: Array,
            default: () => []
        },
        ishaveValue: {
            type: Boolean,
            default: () => false
        }
    },
    data: () => ({
        roleService: RoleService,

        // permissions: [],
        
        roles: [],
        
        checkedPermissions: [],

        checkedRoles_: [],

        all: false,

        uncheck: [],

        allPermissions: [],

        checkedAllPermissionInRoles: []

    }),
    watch: {
        checked(checked) {
            this.checkedAllPermissionInRoles = [];
            this.checkedPermissions = checked;
            this.roles.forEach(role => {
                const checkedCount = this.rolePermissionsCheckedCount(
                    role.permissions
                );
                if (checkedCount == role.permissions.length) {
                    this.checkedAllPermissionInRoles.push(role.id);
                }
            });
        },
        checkedPermissions(checked) {
            
            this.$emit("update:checked", checked);

        },
        checkedRoles(roles) {
            this.checkedRoles_ = roles;
        },
        checkedRoles_(roles) {
            this.$emit("update:checkedRoles", roles)
        },

        allPermissions() {

            let checked = this.checkedPermissions.length;

            let allPermissions = this.allPermissions.length;

            this.all = checked == allPermissions;
        }

    },
    mounted() {
        this.fetchRoles();
        this.getAllPermissions();
        
        // this.checkedPermissions = this.checked;

        // console.log(this.checked);

        // alert();
    },
    methods: {
        async fetchRoles() {
            const params = { includes: "permissions" };
            const response = await this.roleService.all(params);
            this.roles = JsonDenormalizer.denormalize(response);
        },
        rolePermissionsCheckedCount(permissions) {
            const count = permissions.filter(permission => {
                return this.checkedPermissions.includes(permission.id);
            }).length;
            return count;
        },
        toggleAllRoles(value) {
            if (value) {
                this.checkedRoles_ = this.roles.map(role => role.id);
            } else {
                this.checkedRoles_ = [];
            }
        },
        checkAll(role) {

            if (this.checkedAllPermissionInRoles.includes(role.id)) {
                
                role.permissions.forEach(permission => {

                    const index = this.checkedPermissions.indexOf( permission.id );

                    if (index == -1) {
                        
                        this.checkedPermissions.push(permission.id);

                    }
                
                });

            } else {
                role.permissions.forEach(permission => {

                    const index = this.checkedPermissions.indexOf(
                        permission.id
                    );
                    
                    // if (index > -1) {
                        this.checkedPermissions.splice(index, 1);
                    // }
                    
                });
            }
        },

        checkAllPermission() {

            this.checkedPermissions = [];

            if (this.all) {

                this.allPermissions.forEach(permission => {

                    this.checkedPermissions.push(permission.id);
                
                });

            }     

        },

        rolePermissions(role) {

            let permissions = [];

            role.permissions.forEach(x => {

                if (permissions.find(permission => x.name == permission.name)) {

                
                }else{
                    
                    permissions.push(x);

                }

            });
            
            return permissions.sort((a, b) => {

                var x = a.name.toLowerCase(), y = b.name.toLowerCase();
    
                return x < y ? -1 : x > y ? 1 : 0;

            });

            // console.log(permissions);

        },


        getAllPermissions() {

            PermissionService.all({type:'user'}).then(response => {

                this.allPermissions = JsonDenormalizer.denormalize(response);

            });

        }

    },

    computed: {
        areAllRolesChecked() {
            const roleIds = this.roles.map(role => role.id);
            return roleIds.every(roleId => this.checkedRoles_.includes(roleId));
        },

        // allPermissions() {

        //     let permissions = [];

        //     this.roles.forEach(role => {

        //         role.permissions.forEach(x => {

        //             if (permissions.find(permission => x.name == permission.name)) {

                
        //             }else{
                        
        //                 permissions.push(x);

        //             }

        //         })

        //     });

        //     return permissions.sort((a, b) => {

        //         var x = a.name.toLowerCase(), y = b.name.toLowerCase();
    
        //         return x < y ? -1 : x > y ? 1 : 0;

        //     });

        // }

    }


};
</script>

<style lang="scss" scoped>
.permissions {
    margin-top: -5px;
    margin-right: 0;
}
.permission {
    padding: 5px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/rolesAndPermissions.vue